import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { useTagMutations } from 'containers/Tags/useTagMutations';
import { prefetchGridSchema } from '../-utils/loaders';

function TagsRoute() {
  const { customList, customAdd, customChange } = useTagMutations();
  return (
    <BaseView
      configuration={baseModuleConfigs.Tags}
      customList={customList}
      customAdd={customAdd}
      customChange={customChange}
    />
  );
}

export const Route = createFileRoute('/_authenticated/tags')({
  loader: ({ context }) =>
    prefetchGridSchema(context.queryClient, baseModuleConfigs.Tags.itemType),
  component: TagsRoute,
});
